<!-- eslint-disable vue/no-bare-strings-in-template -->
<template>
  <section class="miniStack">
    <div>
      <BaseCard variant="light" class="mt-4">
        <h3>A generic table with selection</h3>
        <GenericTable
          class="mt-4"
          :class="$style.table"
          withSelection
          :rows="
            files.map((f) => {
              return {
                ...f,
                isSelected: selectedRows.includes(f.id),
              };
            })
          "
          :headers="[
            {
              text: 'Name',
              value: 'name',
              style: 'text-align: left; --justifyContent: normal;',
            },
            {
              text: 'Revision',
              value: 'revisionNumber',
            },
            {
              text: 'Parts in file',
              value: 'totalParts',
              style: 'width: 15ch',
            },
            {
              text: 'Quantity',
              value: 'quantity',
              style: 'width: 0',
            },
            {
              text: 'Assembly',
              value: 'assembly',
            },
            {
              text: 'Reference',
              value: 'reference',
            },
          ]"
          @on-selected="handleSelected"
        />
      </BaseCard>
      <BaseCard variant="light" class="mt-4">
        <h3>A generic table with sorting</h3>
        <GenericTable
          class="mt-4"
          :class="$style.table"
          withSorting
          :rows="
            files.map((f) => {
              return {
                ...f,
              };
            })
          "
          :headers="[
            {
              text: 'Name',
              value: 'name',
              style: 'text-align: left; --justifyContent: normal;',
            },
            {
              text: 'Revision',
              value: 'revisionNumber',
            },
            {
              text: 'Parts in file',
              value: 'totalParts',
              style: 'width: 15ch',
            },
            {
              text: 'Quantity',
              value: 'quantity',
              style: 'width: 0',
            },
            {
              text: 'Assembly',
              value: 'assembly',
            },
            {
              text: 'Reference',
              value: 'reference',
            },
          ]"
        />
      </BaseCard>
    </div>
    <div>&nbsp;</div>
    <h3>A generic table with custom renders</h3>
    <GenericTable
      :class="$style.table"
      withSelection
      withSorting
      :rows="
        files.map((f) => {
          return {
            ...f,
            isSelected: selectedRows.includes(f.id),
          };
        })
      "
      :headers="[
        {
          text: 'Name',
          value: 'name',
          style: 'text-align: left; --justifyContent: normal;',
        },
        {
          text: 'Revision',
          value: 'revisionNumber',
          style: 'width: 0',
        },
        {
          text: 'Parts in file',
          value: 'totalParts',
          style: 'width: 15ch',
        },
        {
          text: 'Quantity',
          value: 'quantity',
          style: 'width: 0',
        },
        {
          text: 'Select',
          value: 'id',
          style: 'width: 0',
          disableSort: true,
        },
        {
          text: 'Assembly',
          value: 'assembly',
          style: 'width: 0',
        },
        {
          text: 'Reference',
          value: 'reference',
          style: 'width: 18ch',
        },
      ]"
      class="mt-4"
      style="
        --theadBackground: var(--neutral-300);
        --tbodyBackground: var(--neutral-50);
        --thPadding: 1rem 0.5rem;
      "
      @on-selected="handleSelected"
    >
      <template #id>
        <CButton
          icon="layers"
          size="sml"
          color="white"
          :tooltip="$t('order:fileOptions:selectAndGotoMaterialTabTooltip')"
          @click.stop
        />
      </template>
      <template #quantity="{ row }">
        <input v-model="getFile(row.id).quantity" type="number" @click.stop />
      </template>
      <template #assembly="{ row }">
        <div class="flex h-[inherit] items-center justify-center p-1">
          <ToggleBoolean v-model="getFile(row.id).assembly" />
        </div>
      </template>
      <template #reference="{ row }">
        <input v-model="getFile(row.id).reference" type="text" @click.stop />
      </template>
    </GenericTable>
  </section>
</template>
<script setup lang="ts">
import { ref } from 'vue';
const files = ref([
  {
    id: 'bla',
    name: 'Very long name for this file without any extension',
    reference: 'ref1',
    revisionNumber: 1,
    totalParts: 10,
    quantity: 1,
    assembly: false,
  },
  {
    id: 'blabla',
    name: 'file_corpus_dot_meta.splt',
    reference: 'ref2',
    revisionNumber: 2,
    totalParts: 20,
    quantity: 2,
    assembly: true,
  },
  {
    id: 'blablabla',
    name: 'file_with_revision_after_approval_from_customer.splt',
    reference: 'ref3',
    revisionNumber: 3,
    totalParts: 30,
    quantity: 3,
    assembly: false,
  },
]);

const selectedRows = ref<string[]>([]);
function handleSelected(checked: boolean, file: { id: string }) {
  const selected = [...selectedRows.value];

  if (checked) {
    selected.push(file.id);
  } else {
    selected.splice(
      selected.findIndex((id) => id === file.id),
      1
    );
  }

  selectedRows.value = selected;
}

function getFile(id: string) {
  return files.value.find((f) => f.id === id)!;
}
</script>
<style module>
.table input {
  border: 1px solid var(--neutral-400);
  background-color: var(--color-white);
  max-width: 12ch;
  padding: 0.25rem 0.5rem;
  border-radius: 1rem;

  &[type='number'] {
    max-width: 8ch;
  }
}
</style>
